import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import GalleryService from '@/services/gallery.service';
import XIcon        from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text         from '@/shared-components/text/components/Text';

import './styles/DeletePost.css';

export default function DeletePost({ open, close, fetchData, mode = 'post' }) {
  const { stateHandler, cacheHandler } = useStateHandler();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function deletePostHandler() {
    setLoading(true);
    try {
      const { response } = await GalleryService.removePostDraft(fetchData._id);

      if (response.ok) {
        // build the popup message based on mode
        const message =
          mode === 'article'
            ? `${fetchData.post_container.post_title} deleted successfully`
            : 'Post deleted successfully';
        stateHandler.set("temporalPopup", { text: message });
        cacheHandler.triggerAction("DELETE_POST");
        close();
        navigate("/profile/board", { replace: true });
      } else {
        console.error("[DeletePost] server returned error:", response.status);
        close(); // still close on error
      }
    } catch (err) {
      console.error("[DeletePost] network or parse error:", err);
      close();
    } finally {
      setLoading(false);
    }
  }

  return (
    <GenericPopup
      className="delete-post-popup"
      open={open}
      darkerBlur
      onCloseAction={close}
      closeButtonText="Keep it"
      onConfirm={deletePostHandler}
      confirmButtonText="Delete"
    >
      <div className="delete-post-popup__header">
        <span className="delete-post-popup__header-spacer" />
        <Text className="delete-post-popup__header-text">
          Delete post
        </Text>
        <XIcon
          className="delete-post-popup__close"
          onClick={close}
        />
      </div>

      {/* body text */}
      <Text
        className="delete-post-popup__text"
        paragraph
      >
        Are you sure you want to delete this post?
      </Text>
    </GenericPopup>
  );
}
